export default __webpack_public_path__ + "static/media/dotboundary-fixed.bc51fc31.otf";